import { render, staticRenderFns } from "./GenericHeader.vue?vue&type=template&id=6f7ab04c&scoped=true"
import script from "./GenericHeader.vue?vue&type=script&lang=js"
export * from "./GenericHeader.vue?vue&type=script&lang=js"
import style0 from "./GenericHeader.vue?vue&type=style&index=0&id=6f7ab04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ab04c",
  null
  
)

export default component.exports